import { Card } from "primereact/card"
import "./JobCard.css"
import { Tag } from "primereact/tag"
import moment from "moment";
import OpenJobDetails from "../openJobDetails/OpenJobDetails";
import { useState } from "react";

function JobCard({job}){
    const [openJobDetailsVisible, setOpenJobDetailsVisible] = useState(false);

    const applicantSigninUrl = `${globalThis.location.origin}/applicant-signin`;
    const departmentStyles = {
        Engineering: {
            backgroundColor: "#ECFDF5",
            color: "#059669",
            border: "1px solid #A7F3D0"
        },
        Data: {
            backgroundColor: "#EFF6FF",
            color: "#2563EB",
            border: "1px solid #BFDBFE"
        },
        Infra: {
            backgroundColor: "#FFFBEB",
            color: "#D97706",
            border: "1px solid #FDE68A"
        },
        Operations: {
            backgroundColor: "#F5F3FF",
            color: "#7C3AED",
            border: "1px solid #DDD6FE"
        }
    }

    const workTypeStyles = {
        "Full-time": {
            backgroundColor: "#E0F2FE",
            color: "#0369A1",
            border: "1px solid #7DD3FC"
        },
        "Part-time": {
            backgroundColor: "#FDF4FF",
            color: "#C026D3",
            border: "1px solid #F5D0FE"
        }
    }

    const locationStyles = {
        Remote: {
            backgroundColor: "#22c55e",
            color: "#ffffff"
        },
        "On-site": {
            backgroundColor: "#8b5cf6",
            color: "#ffffff"
        }
    }

    const getDepartmentStyle = (department) => {
        return departmentStyles[job.department] || {
            backgroundColor: "#F3F4F6",
            color: "#374151",
            border: "1px solid #E5E7EB"
        }
    }

    const getWorkTypeStyle = (workType) => {
        return workTypeStyles[job.workType] || {
            backgroundColor: "#E5E7EB",
            color: "#374151"
        }
    }

    const getLocationStyle = (location) => {
        return locationStyles[job.location] || {
            backgroundColor: "#3b82f6",
            color: "#ffffff"
        }
    }

    const header = (
        <div className="job-card-header">
            <div className="job-card-header-left-tags">
                <Tag value={job.department} style={getDepartmentStyle(job.department)} />
            </div>
            <div className="job-card-header-right-tags">
                <Tag value={job.workType} style={getWorkTypeStyle(job.workType)} />
                <Tag value={job.location} style={getLocationStyle(job.location)} />
            </div>
        </div>
    )

    return(
        <>
            <Card header={header} title={job.jobTitle} className="job-card" onClick={() => setOpenJobDetailsVisible(true)}>
                <div>
                    <p title={job.jobDescription} className="job-card-job.description">{job.jobDescription}</p>
                </div>
                <div className="job-card-footer">
                    <div className="job-card-footer-top">
                        <div><span><i className="pi pi-map-marker"></i> {job.location}</span></div>
                        <div><span>{job.offerRate}</span></div>
                    </div>
                    <div className="job-card-footer-bottom">
                        <span><i className="pi pi-clock"></i> {moment(job.createdAt).fromNow()}</span>
                    </div>
                    
                </div>
            </Card>
            <OpenJobDetails
                job={job}
                visible={openJobDetailsVisible}
                onHide={() => setOpenJobDetailsVisible(false)}
                applicantSigninUrl={applicantSigninUrl}
            />
        </>
    )
}

export default JobCard;